import React, { SVGProps } from 'react';

const CopyToClipboardIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none" {...props}>
            <path
                d="M9.26048 0.864492C8.74268 0.313945 8.02081 0.00121875 7.26499 0H5.74999C4.32914 0.00222656 3.1433 1.08518 3.01249 2.50001H2.74999C1.2319 2.50165 0.00164063 3.73191 0 5.25V9.25001C0.00164063 10.7681 1.2319 11.9983 2.74999 12H4.74998C6.26808 11.9983 7.49834 10.7681 7.49998 9.25001V8.98751C8.9149 8.85691 9.99799 7.67095 9.99998 6.25001V2.73499C10.001 2.04002 9.73645 1.37091 9.26048 0.864492ZM6 9.25001C6 9.94036 5.44036 10.5 4.75001 10.5H2.74999C2.05964 10.5 1.5 9.94036 1.5 9.25001V5.25C1.5 4.55965 2.05964 4.00001 2.74999 4.00001H3V6.25001C3.00164 7.7681 4.2319 8.99834 5.74999 9H6V9.25001ZM8.49998 6.25001C8.49998 6.94036 7.94034 7.5 7.24999 7.5H5.74999C5.05964 7.5 4.5 6.94036 4.5 6.25001V2.74999C4.5 2.05964 5.05964 1.5 5.74999 1.5H6.99998V1.99999C6.99998 2.55227 7.44771 3 7.99999 3H8.49998V6.25001Z"
                fill="#CBCBCB"
            />
        </svg>
    );
};

export default CopyToClipboardIcon;
